import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button,
  TextField,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";

const ManageInventory = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const products = [
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Variant 1",
      price: "$99.99",
      quantity: 50,
      purchaseLimit: 10,
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Variant 1",
      price: "$99.99",
      quantity: 50,
      purchaseLimit: 10,
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Variant 1",
      price: "$99.99",
      quantity: 50,
      purchaseLimit: 10,
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Variant 1",
      price: "$99.99",
      quantity: 50,
      purchaseLimit: 10,
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Variant 1",
      price: "$99.99",
      quantity: 50,
      purchaseLimit: 10,
      image: "/static/images/placeholder.png",
    },
  ];

  const filteredProducts = products.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="main_title">
        <h1>Inventory Management</h1>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
        </div>

        <TableContainer className="table_container" sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Product ID</TableCell>
                <TableCell>Product Details</TableCell>
                <TableCell>Variant Name</TableCell>
                <TableCell>Selling Price</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Purchase Limit</TableCell>
                <TableCell>Out Of Stock</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredProducts.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "4px",
                          objectFit: "cover",
                          background: "#f5f5f5",
                        }}
                      />
                      <span>{item.name}</span>
                    </Box>
                  </TableCell>

                  <TableCell>{item.variant}</TableCell>
                  <TableCell>
                    <b>{item.price}</b>
                  </TableCell>
                  <TableCell>
                    <TextField
                      id="email"
                      name="email"
                      type="email"
                      placeholder="50"
                      sx={{
                        width: 80,
                        border: "1px solid #F2F1F6",
                        borderRadius: "5px",
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      id="email"
                      name="email"
                      type="email"
                      placeholder="10"
                      sx={{
                        width: 80,
                        border: "1px solid #F2F1F6",
                        borderRadius: "5px",
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>

                  <TableCell>
                    <div className="tbl_action">
                      <Button
                        variant="contained"
                        className="btn_primary"
                        size="small"
                      
                      >
                        Update
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div style={{ marginTop: "10px", textAlign: "right" }}>
          <p>Showing 1 to 5 of 5 entries</p>
        </div>
      </div>
    </>
  );
};

export default ManageInventory;
